import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { ListLayout } from '../../global/tables/table-list-layout';
import TableLoadingRow from '../../global/tables/table-loading-row';
import DefaultButton from '../../global/default-button/default-button';
import { UserGroupsVM } from '../user-groups.viewmodel';
import { IUserGroupDTO } from '../../../api/user-groups.dao';
import { Paging } from '../../global/_paging/paging-container';
import { UserGroupsListItem } from './_user-groups-list-item/user-groups-list-item';
import { DESCRIPTION } from '../../../constants/common-labels.constants';

interface IProps {
    intl: IntlShape;
    vm: UserGroupsVM;
}

const UserGroupsList = injectIntl(
    mobxReact.observer((props: IProps) => {
        const { vm, intl } = props;
        const { userGroupsList, showCreateGroupForm, isLoading } = vm;

        const title = intl.formatMessage({
            id: 'oe.userGroups.pageTitle',
            defaultMessage: 'User Groups',
            description: 'Section header'
        });

        const thead = [
            intl.formatMessage({
                id: 'oe.common.name',
                description: 'Label text',
                defaultMessage: 'Name'
            }),
            intl.formatMessage(DESCRIPTION)
        ];

        const isEmpty = !userGroupsList?.length;

        return (
            <div className='page-container'>
                <section className='top-page-title horizontal-row horizontal-row--with-bottom-margin'>
                    <h1 className='text-ellipsis'>{title}</h1>
                    <div className='horizontal-row__align-to-row-end'>
                        <div className='buttons-block'>
                            <DefaultButton
                                className='events-list__button-new'
                                modifier='fat'
                                text={intl.formatMessage(
                                    {
                                        id: `oe.userGroups.newUserGroup`,
                                        description: 'New User button',
                                        defaultMessage: '{prefix}New User Group'
                                    },
                                    {
                                        prefix: '+ '
                                    }
                                )}
                                onClick={() => showCreateGroupForm(intl)}
                            />
                        </div>
                    </div>
                </section>
                <section className='accounts-list fixed-list-layout'>
                    <div>
                        <ListLayout thead={thead}>
                            {!isLoading && !isEmpty && userGroupsList.map((item: IUserGroupDTO) => {
                                    return (
                                        <UserGroupsListItem
                                            isGroupSelected={vm.isGroupFormShown(item.userGroupId)}
                                            handleEditGroupClick={vm.editGroup}
                                            key={item.userGroupId}
                                            {...item}
                                        />
                                    );
                                })}
                            {isLoading && <TableLoadingRow colSpan={thead.length} />}
                        </ListLayout>
                        {!isLoading && isEmpty && (
                            <div className='empty-list-message'>
                                <FormattedMessage
                                    description='User groups list empty text'
                                    defaultMessage='There are no user groups.'
                                    id='oe.userGroups.emptyListText'
                                />
                            </div>
                        )}
                    </div>
                </section>
                {!isLoading && <Paging pagingVM={vm.paginationVM} />}
            </div>
        );
    })
);

export default UserGroupsList;
